import { useState } from "react";
import Start_Btn from "../../common/start-btn/Start_Btn";
import Fill_Form_Modal from "../../modals/fill-form-modal/Fill_Form_Modal";
import { useNavigate } from "react-router-dom";

const Parental_Assessment = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  return (
    <section className="Start_Assessment">
      <div className="container">
        <div className="black_div">
          <h5 className="div_title">
            Support Your Child’s Future with Confidence
          </h5>
          <p className="div_subtitle">
            Get professional guidance to make informed and practical career
            decisions.
          </p>
          <Start_Btn
            text="Start Assessment"
            onClick={() => navigate(`/test-instructions`)}
          />
        </div>
      </div>
      <Fill_Form_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </section>
  );
};

export default Parental_Assessment;
